/* eslint import/prefer-default-export: 0 */

import get from 'lodash/get';

export function normalizeAddress(data = {}) {
  const components = get(data, 'address_components', []).reduce((memo, item) => {
    const key = get(item, 'types[0]');
    return key
      ? Object.assign({}, memo, {
          [key]: item.long_name
        })
      : memo;
  }, {});
  const formattedAddress = data.formatted_address || '';
  const city = components.locality || components.administrative_area_level_2 || '';

  return {
    city,
    postcode: components.postal_code || '',
    state: components.administrative_area_level_1 || '',
    streetAddress: city
      ? formattedAddress.replace(new RegExp(`[, ]+\\b${city}\\b.*$`), '')
      : formattedAddress
  };
}
